import { Box } from '@chakra-ui/react/box';
import { useSlotRecipe, useToken } from '@chakra-ui/react/styled-system';
import { Text } from '@chakra-ui/react/text';
import { Toast, Toaster } from '@chakra-ui/react/toast';

import { IconArrowNortheast } from '../../icons';
import BitkitCloseButton from '../BitkitCloseButton/BitkitCloseButton';
import BitkitColorButton from '../BitkitColorButton/BitkitColorButton';
import { BUTTON_COLORS_MAP, ICON_COMPONENTS_MAP } from '../common/notificationMaps';
import { type BitkitToastVariant, toaster } from './BitkitToast';

const BitkitToaster = () => {
  const toastRecipe = useSlotRecipe({ key: 'toast' });
  const [zIndex] = useToken('zIndex', 'toast');

  return (
    <Toaster toaster={toaster} style={{ zIndex }}>
      {(toast) => {
        const variant = toast.type as BitkitToastVariant;
        const styles = toastRecipe({ closable: toast.closable, variant });
        const IconComponent = ICON_COMPONENTS_MAP[variant];
        return (
          <Toast.Root variant={variant} {...toast.meta?.dataAttributes}>
            <IconComponent css={styles.icon} />
            <Box css={styles.content}>
              {!!toast.title && <Toast.Title>{toast.title}</Toast.Title>}
              <Toast.Description>{toast.description}</Toast.Description>
              {!!toast.meta?.action &&
                (toast.meta.action.href !== undefined ? (
                  <BitkitColorButton
                    colorVariant={BUTTON_COLORS_MAP[variant]}
                    css={styles.actionTrigger}
                    href={toast.meta.action.href}
                    isExternal={toast.meta.action.isExternal || toast.meta.action.target === '_blank'}
                    onClick={toast.meta.action.onClick}
                    state={toast.meta.action.state}
                    suffixIcon={toast.meta.action.isExternal ? IconArrowNortheast : undefined}
                    target={toast.meta.action.target}
                  >
                    {toast.meta.action.label}
                  </BitkitColorButton>
                ) : (
                  <BitkitColorButton
                    colorVariant={BUTTON_COLORS_MAP[variant]}
                    css={styles.actionTrigger}
                    onClick={toast.meta.action.onClick}
                    state={toast.meta.action.state}
                  >
                    {toast.meta.action.label}
                  </BitkitColorButton>
                ))}
              {!!toast.meta?.timestamp && <Text css={styles.timestamp}>{toast.meta.timestamp}</Text>}
            </Box>
            {toast.closable && (
              <Toast.CloseTrigger asChild>
                <BitkitCloseButton
                  aria-label="Dismiss notification"
                  colorVariant={BUTTON_COLORS_MAP[variant]}
                  size="sm"
                  tooltipText="Dismiss"
                />
              </Toast.CloseTrigger>
            )}
          </Toast.Root>
        );
      }}
    </Toaster>
  );
};

export default BitkitToaster;
